module.exports = __webpack_public_path__ + "img/germany-lung-cancer-female.b3b18b2b.png";